var _rect, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRss(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 18,
    height: 18,
    rx: 9
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_9905_206124)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_9905_206124)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.00166 12.666C5.26366 12.666 4.66566 13.264 4.66699 14C4.66699 14.736 5.26433 15.334 6.00166 15.3327C6.73699 15.334 7.33499 14.7367 7.33366 14C7.33499 13.262 6.73699 12.6647 6.00166 12.666Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.00033 4.66669C5.26433 4.66669 4.66699 5.26402 4.66699 6.00002C4.66699 6.73602 5.26433 7.33335 6.00033 7.33335C9.67633 7.33335 12.667 10.324 12.667 14C12.667 14.736 13.2643 15.3334 14.0003 15.3334C14.7363 15.3334 15.3337 14.736 15.3337 14C15.3337 8.85335 11.147 4.66669 6.00033 4.66669Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.00033 8.66669C5.26433 8.66669 4.66699 9.26402 4.66699 10C4.66699 10.736 5.26433 11.3334 6.00033 11.3334C7.47033 11.3334 8.66699 12.5294 8.66699 14C8.66699 14.736 9.26433 15.3334 10.0003 15.3334C10.7363 15.3334 11.3337 14.736 11.3337 14C11.3337 11.0594 8.94099 8.66669 6.00033 8.66669Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_9905_206124"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    fill: "white",
    transform: "matrix(-1 0 0 1 16 4)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_9905_206124"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    fill: "white",
    transform: "translate(4 4)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRss);
export default __webpack_public_path__ + "static/media/rss.a98ceafcb85c40a87a047c9cdde2a601.svg";
export { ForwardRef as ReactComponent };